module.exports = __webpack_public_path__ + "static/media/cd.2ac94b0f.png";